import { render, staticRenderFns } from "./SeatSelectPassenger.vue?vue&type=template&id=55fc8d6a&scoped=true&"
import script from "./SeatSelectPassenger.vue?vue&type=script&lang=js&"
export * from "./SeatSelectPassenger.vue?vue&type=script&lang=js&"
import style0 from "./SeatSelectPassenger.vue?vue&type=style&index=0&id=55fc8d6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc8d6a",
  null
  
)

export default component.exports